import { useEffect } from 'react';
import { useRouter } from 'next/router';

/**
 * @deprecated Moved to /nonprofits/apply
 */
export default function SignupNonProfitRedirect() {
  const router = useRouter();

  useEffect(() => {
    router.push("/nonprofits/apply");
  }, [router]);

  return <div>Redirecting...</div>
}